import React from 'react';

import { Button } from '@infoods/lifebase-ui';

import { angularizeWithProviders } from '../../providers';
import { ErrorState } from '../../components/ErrorState/ErrorState';
import { goToHomePage } from '../../utils/angularUtils';
import { PaymentFlowType } from '../../constants/user-info/paymentFlowType';
import { getHumanizePaymentFlowType } from '../../utils/userInfoUtils/getHumanizePaymentFlowType/getHumanizePaymentFlowType';

type UnsupportedPaymentFlowErrorProps = {
  paymentFlowType: PaymentFlowType | null;
};

const UnsupportedPaymentFlowError = ({
  paymentFlowType,
}: UnsupportedPaymentFlowErrorProps) => {
  const paymentFlowName = paymentFlowType
    ? getHumanizePaymentFlowType(paymentFlowType)
    : 'this payment flow';

  return (
    <ErrorState
      title="This page is no longer available"
      description={`Support for ${paymentFlowName} has been discontinued and the related pages were removed.`}
    >
      <Button variant="contained" onClick={goToHomePage}>
        Return to the Main Page
      </Button>
    </ErrorState>
  );
};

angularizeWithProviders(UnsupportedPaymentFlowError, 'ngzUnsupportedPaymentFlowError', {
  paymentFlowType: '<',
});

export { UnsupportedPaymentFlowError };
